import { Supporter } from '@/types';
import { SearchTreeNode } from '@/types/searchTreeTypes';
import OtherActionsPanelLayout from '@components/OtherActionsPanelContent/shared/OtherActionsPanelLayout';
import { useOtherActionsPanelForm } from '@components/OtherActionsPanelContent/shared/useOtherActionsPanelForm';
import { useOtherActionsPanelList } from '@components/OtherActionsPanelContent/shared/useOtherActionsPanelList';
import { useOtherActionsPanelTreeApply } from '@components/OtherActionsPanelContentAdv/useOtherActionsPanelTreeApply';
import { extractContactIdsFromTree } from '@components/OtherActionsPanelContentAdv/util';

interface OtherActionsPanelContentAdvProps {
  onClose: (isSuccessful: boolean) => void;
  tree?: SearchTreeNode;
  sortOrder?: string;
  sortColumn?: string;
  listId?: number;
  listCount?: number;
  selectedContacts?: Supporter[];
}

export default function OtherActionsPanelContentAdv({
  onClose: handleClose,
  tree,
  sortOrder = 'asc',
  sortColumn = 'id',
  listCount = 0,
  listId = 0,
  selectedContacts,
}: OtherActionsPanelContentAdvProps) {
  const { otherActionList, ACCORDION_STARTING_STATE } = useOtherActionsPanelList();
  const selectedContactIds = extractContactIdsFromTree(tree);
  const form = useOtherActionsPanelForm({
    accordionStartingState: ACCORDION_STARTING_STATE,
    listId,
    sortColumn,
    sortOrder,
    contactIds: selectedContactIds,
    selectedContacts,
  });
  const { applyLoading, handleApply } = useOtherActionsPanelTreeApply({
    form,
    tree,
    listId,
    sortOrder,
    sortColumn,
    selectedContactIds,
    onClose: handleClose,
  });

  return (
    <OtherActionsPanelLayout
      form={form}
      otherActionList={otherActionList}
      listId={listId}
      listCount={listCount}
      sortOrder={sortOrder}
      sortColumn={sortColumn}
      contactIds={selectedContactIds}
      selectedContacts={selectedContacts}
      applyLoading={applyLoading}
      onApply={handleApply}
      onCancel={() => {
        form.resetInternalState();
        handleClose(false);
      }}
      taskNotesLabel="Add a note (optional)"
    />
  );
}
